import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import jwt_decode from 'jwt-decode';
import { AuthService } from 'src/services/auth.service';
import { map } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class AdminGuard {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private authService: AuthService
  ) { }

  canActivate() {
    if (!isPlatformBrowser(this.platformId))
      return false;

    let userFromStorage = localStorage.getItem('currentUser') ? localStorage.getItem('currentUser') : null;

    if (userFromStorage == null) {
      this.router.navigate(['/auth']);
      return false;
    }

    let currentUser = JSON.parse(userFromStorage);

    if (!currentUser || !currentUser.token || !currentUser.user) {
      this.router.navigate(['/auth']);
      return false;
    }

    let tokenPayload: any = jwt_decode(currentUser.token);
    let nowTimestamp = new Date().getTime() / 1000;
    if (nowTimestamp >= tokenPayload.exp) {
      this.router.navigate(['/auth']);
      return false;
    }

    if(currentUser.user.roleId < 10) {
      this.router.navigate(['/home']);
      return false;
    }

    return true;
  }
}
